import { getOffset } from './_getOffset';

export function stickyTrigger() {
  const baseElement = document.querySelector('.js-header-trigger');

  let baseElementOffsetTop = '';

  const setSize = () => {
    const baseElementOffset = getOffset(baseElement);
    baseElementOffsetTop = baseElementOffset.top;
  }

  const scroller = () => {
    const scTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
    if(baseElementOffsetTop <= scTop) {
      document.body.classList.add('is-trigger-fixed');
    } else {
      document.body.classList.remove('is-trigger-fixed');
    }
  }

  window.addEventListener('resize', () => {
    setSize();
    scroller();
  });

  window.addEventListener('scroll', scroller);

  setSize();
  scroller();
}